// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import {
	AnnouncementSelectField,
	CalendarEventResponseSelectField,
	CalendarEventSelectField,
	ContractSelectField,
	CourseAssessmentMarkSelectField,
	CourseAssessmentSelectField,
	CourseAssessmentSubmissionSelectField,
	CourseAttendanceRecordSelectField,
	LoginRecordSelectField,
	MessageAvailabilityPeriodSelectField,
	MessageGroupArchivePointSelectField,
	MessageGroupSelectField,
	MessageSelectField,
	MFAFactorSelectField,
	MFAInvalidOTPAttemptSelectField,
	NewsletterSelectField,
	PermissionGroupSelectField,
	PersonSelectField,
	PostSelectField,
	ReportCardSectionSelectField,
	ReportCardSelectField,
	SchoolAttendanceRecordSelectField,
	SessionSelectField,
	SharingRecordSelectField,
	SocialCommentSelectField,
	SocialReactionSelectField,
	StudentDataConsentSelectField,
	StudentInformationVerificationSelectField,
	StudentMedicalEventSelectField,
	StudentNoteSelectField,
	TrustedDeviceSelectField,
	UserGroupSelectField,
	UserViewRecordSelectField,
} from "../../Forms";
import { UserFormValues } from "../../FormUtilities";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues &
	IndexForms.SearchFormValues &
	IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialSearchFormValues,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.searchFormValuesFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "email" },
		{ value: "status" },
		{ value: "passwordUpdatedAt" },
		{ value: "isCurrent" },
		{ value: "timeZoneName" },
		{ value: "externalNotificationFrequency" },
		{ value: "approvedContracts" },
		{ value: "approvedReportCards" },
		{ value: "authoredAnnouncements" },
		{ value: "authoredCalendarEventResponses" },
		{ value: "authoredCalendarEvents" },
		{ value: "authoredCourseAssessmentMarks" },
		{ value: "authoredCourseAssessmentSubmissions" },
		{ value: "authoredCourseAssessments" },
		{ value: "authoredCourseAttendanceRecords" },
		{ value: "authoredMessageGroupArchivePoints" },
		{ value: "authoredMessages" },
		{ value: "authoredNewsletters" },
		{ value: "authoredPosts" },
		{ value: "authoredSchoolAttendanceRecords" },
		{ value: "authoredSocialComments" },
		{ value: "authoredSocialReactions" },
		{ value: "authoredStudentDataConsents" },
		{ value: "authoredStudentInformationVerifications" },
		{ value: "authoredStudentMedicalEvents" },
		{ value: "authoredStudentNotes" },
		{ value: "loginRecords" },
		{ value: "memberGroups" },
		{ value: "messageAvailabilityPeriods" },
		{ value: "messageGroups" },
		{ value: "mfaFactor" },
		{ value: "mfaInvalidOTPAttempts" },
		{ value: "permissionGroups" },
		{ value: "person" },
		{ value: "sessions" },
		{ value: "sharedSharingRecords" },
		{ value: "sharingRecords" },
		{ value: "submittedReportCardSections" },
		{ value: "trustedDevices" },
		{ value: "userGroups" },
		{ value: "userViewRecords" },
	],
	fieldComparisonOptions: {
		email: IndexForms.stringComparisonOptions,
		status: IndexForms.enumComparisonOptions,
		passwordUpdatedAt: IndexForms.timeComparisonOptions,
		isCurrent: IndexForms.booleanComparisonOptions,
		timeZoneName: IndexForms.stringComparisonOptions,
		externalNotificationFrequency: IndexForms.enumComparisonOptions,
		approvedContracts: IndexForms.multipleEdgeComparisonOptions,
		approvedReportCards: IndexForms.multipleEdgeComparisonOptions,
		authoredAnnouncements: IndexForms.multipleEdgeComparisonOptions,
		authoredCalendarEventResponses: IndexForms.multipleEdgeComparisonOptions,
		authoredCalendarEvents: IndexForms.multipleEdgeComparisonOptions,
		authoredCourseAssessmentMarks: IndexForms.multipleEdgeComparisonOptions,
		authoredCourseAssessmentSubmissions: IndexForms.multipleEdgeComparisonOptions,
		authoredCourseAssessments: IndexForms.multipleEdgeComparisonOptions,
		authoredCourseAttendanceRecords: IndexForms.multipleEdgeComparisonOptions,
		authoredMessageGroupArchivePoints: IndexForms.multipleEdgeComparisonOptions,
		authoredMessages: IndexForms.multipleEdgeComparisonOptions,
		authoredNewsletters: IndexForms.multipleEdgeComparisonOptions,
		authoredPosts: IndexForms.multipleEdgeComparisonOptions,
		authoredSchoolAttendanceRecords: IndexForms.multipleEdgeComparisonOptions,
		authoredSocialComments: IndexForms.multipleEdgeComparisonOptions,
		authoredSocialReactions: IndexForms.multipleEdgeComparisonOptions,
		authoredStudentDataConsents: IndexForms.multipleEdgeComparisonOptions,
		authoredStudentInformationVerifications: IndexForms.multipleEdgeComparisonOptions,
		authoredStudentMedicalEvents: IndexForms.multipleEdgeComparisonOptions,
		authoredStudentNotes: IndexForms.multipleEdgeComparisonOptions,
		loginRecords: IndexForms.multipleEdgeComparisonOptions,
		memberGroups: IndexForms.multipleEdgeComparisonOptions,
		messageAvailabilityPeriods: IndexForms.multipleEdgeComparisonOptions,
		messageGroups: IndexForms.multipleEdgeComparisonOptions,
		mfaFactor: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		mfaInvalidOTPAttempts: IndexForms.multipleEdgeComparisonOptions,
		permissionGroups: IndexForms.multipleEdgeComparisonOptions,
		person: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		sessions: IndexForms.multipleEdgeComparisonOptions,
		sharedSharingRecords: IndexForms.multipleEdgeComparisonOptions,
		sharingRecords: IndexForms.multipleEdgeComparisonOptions,
		submittedReportCardSections: IndexForms.multipleEdgeComparisonOptions,
		trustedDevices: IndexForms.multipleEdgeComparisonOptions,
		userGroups: IndexForms.multipleEdgeComparisonOptions,
		userViewRecords: IndexForms.multipleEdgeComparisonOptions,
	},
	fieldComparisonTranslations: {
		email: IndexForms.stringComparisonTranslations,
		status: IndexForms.getRadioComparisonTranslations(UserFormValues.statusOptions),
		passwordUpdatedAt: IndexForms.timeComparisonTranslations,
		isCurrent: IndexForms.booleanComparisonTranslations,
		timeZoneName: IndexForms.stringComparisonTranslations,
		externalNotificationFrequency: IndexForms.getRadioComparisonTranslations(
			UserFormValues.externalNotificationFrequencyOptions,
		),
		approvedContracts: IndexForms.getMultipleEdgeComparisonTranslations(
			ContractSelectField.Select,
			ContractSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		approvedReportCards: IndexForms.getMultipleEdgeComparisonTranslations(
			ReportCardSelectField.Select,
			ReportCardSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredAnnouncements: IndexForms.getMultipleEdgeComparisonTranslations(
			AnnouncementSelectField.Select,
			AnnouncementSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCalendarEventResponses: IndexForms.getMultipleEdgeComparisonTranslations(
			CalendarEventResponseSelectField.Select,
			CalendarEventResponseSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCalendarEvents: IndexForms.getMultipleEdgeComparisonTranslations(
			CalendarEventSelectField.Select,
			CalendarEventSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCourseAssessmentMarks: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseAssessmentMarkSelectField.Select,
			CourseAssessmentMarkSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCourseAssessmentSubmissions: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseAssessmentSubmissionSelectField.Select,
			CourseAssessmentSubmissionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCourseAssessments: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseAssessmentSelectField.Select,
			CourseAssessmentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCourseAttendanceRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseAttendanceRecordSelectField.Select,
			CourseAttendanceRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredMessageGroupArchivePoints: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageGroupArchivePointSelectField.Select,
			MessageGroupArchivePointSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredMessages: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageSelectField.Select,
			MessageSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredNewsletters: IndexForms.getMultipleEdgeComparisonTranslations(
			NewsletterSelectField.Select,
			NewsletterSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredPosts: IndexForms.getMultipleEdgeComparisonTranslations(
			PostSelectField.Select,
			PostSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredSchoolAttendanceRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			SchoolAttendanceRecordSelectField.Select,
			SchoolAttendanceRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredSocialComments: IndexForms.getMultipleEdgeComparisonTranslations(
			SocialCommentSelectField.Select,
			SocialCommentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredSocialReactions: IndexForms.getMultipleEdgeComparisonTranslations(
			SocialReactionSelectField.Select,
			SocialReactionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredStudentDataConsents: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentDataConsentSelectField.Select,
			StudentDataConsentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredStudentInformationVerifications: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentInformationVerificationSelectField.Select,
			StudentInformationVerificationSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredStudentMedicalEvents: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentMedicalEventSelectField.Select,
			StudentMedicalEventSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredStudentNotes: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentNoteSelectField.Select,
			StudentNoteSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		loginRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			LoginRecordSelectField.Select,
			LoginRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		memberGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			UserGroupSelectField.Select,
			UserGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		messageAvailabilityPeriods: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageAvailabilityPeriodSelectField.Select,
			MessageAvailabilityPeriodSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		messageGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageGroupSelectField.Select,
			MessageGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		mfaFactor: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				MFAFactorSelectField.Select,
				MFAFactorSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		mfaInvalidOTPAttempts: IndexForms.getMultipleEdgeComparisonTranslations(
			MFAInvalidOTPAttemptSelectField.Select,
			MFAInvalidOTPAttemptSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		permissionGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			PermissionGroupSelectField.Select,
			PermissionGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		person: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				PersonSelectField.Select,
				PersonSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		sessions: IndexForms.getMultipleEdgeComparisonTranslations(
			SessionSelectField.Select,
			SessionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		sharedSharingRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			SharingRecordSelectField.Select,
			SharingRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		sharingRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			SharingRecordSelectField.Select,
			SharingRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		submittedReportCardSections: IndexForms.getMultipleEdgeComparisonTranslations(
			ReportCardSectionSelectField.Select,
			ReportCardSectionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		trustedDevices: IndexForms.getMultipleEdgeComparisonTranslations(
			TrustedDeviceSelectField.Select,
			TrustedDeviceSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		userGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			UserGroupSelectField.Select,
			UserGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		userViewRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			UserViewRecordSelectField.Select,
			UserViewRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
	},
};

registry.register("User", advancedFilterInformation, {
	approvedContracts: "Contract",
	approvedReportCards: "ReportCard",
	authoredAnnouncements: "Announcement",
	authoredCalendarEventResponses: "CalendarEventResponse",
	authoredCalendarEvents: "CalendarEvent",
	authoredCourseAssessmentMarks: "CourseAssessmentMark",
	authoredCourseAssessmentSubmissions: "CourseAssessmentSubmission",
	authoredCourseAssessments: "CourseAssessment",
	authoredCourseAttendanceRecords: "CourseAttendanceRecord",
	authoredMessageGroupArchivePoints: "MessageGroupArchivePoint",
	authoredMessages: "Message",
	authoredNewsletters: "Newsletter",
	authoredPosts: "Post",
	authoredSchoolAttendanceRecords: "SchoolAttendanceRecord",
	authoredSocialComments: "SocialComment",
	authoredSocialReactions: "SocialReaction",
	authoredStudentDataConsents: "StudentDataConsent",
	authoredStudentInformationVerifications: "StudentInformationVerification",
	authoredStudentMedicalEvents: "StudentMedicalEvent",
	authoredStudentNotes: "StudentNote",
	loginRecords: "LoginRecord",
	memberGroups: "UserGroup",
	messageAvailabilityPeriods: "MessageAvailabilityPeriod",
	messageGroups: "MessageGroup",
	mfaFactor: "MFAFactor",
	mfaInvalidOTPAttempts: "MFAInvalidOTPAttempt",
	permissionGroups: "PermissionGroup",
	person: "Person",
	sessions: "Session",
	sharedSharingRecords: "SharingRecord",
	sharingRecords: "SharingRecord",
	submittedReportCardSections: "ReportCardSection",
	trustedDevices: "TrustedDevice",
	userGroups: "UserGroup",
	userViewRecords: "UserViewRecord",
});
